import { useEffect, useState } from 'react';
import io from 'socket.io-client';

// Use the same backend URL as the API client
const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || 'https://qa-tenantbridge.parablu.com';

export const useSocket = (userEmail) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!userEmail) {
      // If userEmail is null/undefined, disconnect if socket exists
      if (socket) {
        socket.close();
        setSocket(null);
        setConnected(false);
      }
      return;
    }

    const newSocket = io(SOCKET_URL, {
      withCredentials: true,
      transports: ['websocket', 'polling']
    });

    newSocket.on('connect', () => {
      console.log('✅ Socket connected');
      setConnected(true);
      // Join user room (handled automatically by backend based on auth)
      newSocket.emit('join-room', `user:${userEmail.toLowerCase()}`);
    });

    newSocket.on('disconnect', () => {
      console.log('❌ Socket disconnected');
      setConnected(false);
    });

    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
      setConnected(false);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, [userEmail]);

  return { socket, connected };
};

